import { ResizeOptions, ResizePosition } from "./resize/types";

export function getPanGestureAction(props: {
  x: number;
  y: number;
  width: number;
  height: number;
  resizeOptions: Record<ResizePosition, ResizeOptions>;
}): PanGestureAction {
  "worklet";
  const resizeWidth = 55;
  const resizeLength = props.width * 0.6;

  if (
    (props.resizeOptions.top.collapse || props.resizeOptions.top.expand) &&
    props.y < resizeWidth &&
    Math.abs(props.x - props.width / 2) < resizeLength / 2
  ) {
    return "resize-top";
  }

  if (
    (props.resizeOptions.bottom.collapse ||
      props.resizeOptions.bottom.expand) &&
    props.y > props.height - resizeWidth &&
    Math.abs(props.x - props.width / 2) < resizeLength / 2
  ) {
    return "resize-bottom";
  }

  if (
    (props.resizeOptions.left.collapse || props.resizeOptions.left.expand) &&
    props.x < resizeWidth &&
    Math.abs(props.y - props.height / 2) < resizeLength / 2
  ) {
    return "resize-left";
  }

  if (
    (props.resizeOptions.right.collapse || props.resizeOptions.right.expand) &&
    props.x > props.width - resizeWidth &&
    Math.abs(props.y - props.height / 2) < resizeLength / 2
  ) {
    return "resize-right";
  }

  return "rearrange";
}
export type PanGestureAction =
  | "rearrange"
  | "resize-left"
  | "resize-right"
  | "resize-top"
  | "resize-bottom"
  | "ignore"
  | "init";
